import '../../index.css';

function EditNull() {
    return (
        <div className='App'>
            <div className='p-2'>
            <h1 className='text-6xl text-center'>Edit Null</h1>
            <p className='text-white'>
            No blog post provided for edit
            </p>
            </div>
        </div>
    );
}

export default EditNull;
